<template>
    <div id="app">
        <!-- <router-view/> -->

        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
    </div>
</template>

<script>
import './App.scss';

export default {
    name: 'app'
};
</script>
